module.exports = __webpack_public_path__ + "static/media/Readeo_Logo_Light.a7d82401.svg";